import { CodeBase } from "./_codeBase";

/** レイアウト区分*/
export class LayoutDiv extends CodeBase<LayoutDiv>
{
    /** レイアウト区分: "01", "共通", ""*/
    public static readonly GENERAL: LayoutDiv = new LayoutDiv("01", "共通", "general");
    /** レイアウト区分: "02", "ヘッダー" ""*/
    public static readonly HEADER: LayoutDiv = new LayoutDiv("02", "ヘッダー", "header");
    /** レイアウト区分: "03", "詳細" ""*/
    public static readonly DETAIL: LayoutDiv = new LayoutDiv("03", "詳細", "detail");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }
    /**
     * 
     */
    public static List(): LayoutDiv[] {
        return [
            LayoutDiv.GENERAL,
            LayoutDiv.HEADER,
            LayoutDiv.DETAIL,
        ];
    }
}
